/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { BettingPoolV5, BettingPoolV5Interface } from "../BettingPoolV5";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_assetsAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_tournamentAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_gladiatorAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_factionAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "better",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tournamentId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "gladiatorId",
        type: "uint256",
      },
    ],
    name: "BetPlaced",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "userAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address payable",
        name: "relayerAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "functionSignature",
        type: "bytes",
      },
    ],
    name: "MetaTransactionExecuted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "betCountByUser",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "betsByGladiator",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "betsByTournament",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "betsByUser",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tournamentId",
        type: "uint256",
      },
    ],
    name: "claimForGladiator",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "userAddress",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "functionSignature",
        type: "bytes",
      },
      {
        internalType: "bytes32",
        name: "sigR",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "sigS",
        type: "bytes32",
      },
      {
        internalType: "uint8",
        name: "sigV",
        type: "uint8",
      },
    ],
    name: "executeMetaTransaction",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tournamentId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "champion",
        type: "uint256",
      },
    ],
    name: "expectedWinnings",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "getNonce",
    outputs: [
      {
        internalType: "uint256",
        name: "nonce",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "gladiatorPercent",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "incentivesByTournament",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "newAddress",
        type: "address",
      },
    ],
    name: "migrate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "multiplier",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "percent",
        type: "uint8",
      },
    ],
    name: "setGladiatorPercent",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tournamentId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "setIncentive",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tournamentId",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class BettingPoolV5__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _assetsAddress: string,
    _tournamentAddress: string,
    _gladiatorAddress: string,
    _factionAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<BettingPoolV5> {
    return super.deploy(
      _assetsAddress,
      _tournamentAddress,
      _gladiatorAddress,
      _factionAddress,
      overrides || {}
    ) as Promise<BettingPoolV5>;
  }
  getDeployTransaction(
    _assetsAddress: string,
    _tournamentAddress: string,
    _gladiatorAddress: string,
    _factionAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _assetsAddress,
      _tournamentAddress,
      _gladiatorAddress,
      _factionAddress,
      overrides || {}
    );
  }
  attach(address: string): BettingPoolV5 {
    return super.attach(address) as BettingPoolV5;
  }
  connect(signer: Signer): BettingPoolV5__factory {
    return super.connect(signer) as BettingPoolV5__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): BettingPoolV5Interface {
    return new utils.Interface(_abi) as BettingPoolV5Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): BettingPoolV5 {
    return new Contract(address, _abi, signerOrProvider) as BettingPoolV5;
  }
}
